import React from "react";

class Label extends React.Component {
  render() {
    const {
      fontSize,
      fontWeight,
      color,
      opacity,
      textTransform,
      padding,
      lineHeight,
      textAlign,
      wordBreak,
      isComponentToShow,
      ...otherProps
    } = this.props;

    return (
      <div
        style={{
          fontSize,
          fontWeight,
          color,
          opacity,
          textTransform,
          padding,
          lineHeight,
          textAlign,
          whiteSpace: "pre-line",
          wordBreak: wordBreak || "normal",
          ...otherProps,
        }}
        className="label"
      >
        {isComponentToShow
          ? this.props.text
          : typeof this.props.text === "string"
          ? this.props.text
          : typeof this.props.text === "number"
          ? this.props.text
          : ""}
      </div>
    );
  }
}

export default Label;
